import React from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { OPTION_TYPES } from '../stubs.js';

const OPTIONS = [
  {
    id: OPTION_TYPES.CHEAPEST,
    value: false,
    title: 'Cheapest',
    helptext: 'Cheapest service will be select for your return labels.'
  },
  {
    id: OPTION_TYPES.SPECIFIC_SLA,
    value: true,
    title: 'Set a specific service',
    helptext: 'Designate a specific service to be used for all return labels.'
  }
];

export default function ServiceOptions({
  isEnabled = null,
  isDisabled = false,
  onChange = () => {}
}) {
  const onSelect = value => {
    if (isDisabled) return;
    onChange(value);
  };

  const options = OPTIONS.map(option => {
    return (
      <div
        key={option.id}
        className={styles.option}
        data-selected={isEnabled === option.value}
        data-disabled={isDisabled}
        onClick={() => onSelect(option.value)}
      >
        <UiKit.Radio.Group
          name="preferred-carrier-type"
          value={isEnabled}
          disabled={isDisabled}
        >
          <UiKit.Radio.Option value={option.value} label={option.title}>
            <p className={styles.discription}>{option.helptext}</p>
          </UiKit.Radio.Option>
        </UiKit.Radio.Group>
      </div>
    );
  });

  return (
    <UiKit.Flex direction="column" gap={16}>
      {options}
    </UiKit.Flex>
  );
}
